import type { RafScore } from '@seen/request-types/rafScore'
// oxlint-disable-next-line no-restricted-imports
import { useQuery } from '@tanstack/react-query'
import { useContext } from 'react'
import { SeenApiContext } from '#src/contexts/seen-api/SeenApiContext.tsx'
import { cacheKeys } from '#src/hooks/cacheKeys.ts'

interface UseRafScoreResult {
  rafScore: RafScore | null
  isPending: boolean
}

export function useRafScore(patientId: string | undefined): UseRafScoreResult {
  // Some facesheet hosts do not provide the optional AI capability.
  const ai = useContext(SeenApiContext)?.ai
  const canQuery = Boolean(ai && patientId)

  const { data, isPending } = useQuery({
    // oxlint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: cacheKeys.rafScore(patientId),
    queryFn: async (): Promise<RafScore | null> => {
      if (!ai || !patientId) {
        return null
      }
      const { rafScore } = await ai.rafScore({ patientId })
      return rafScore
    },
    enabled: canQuery,
  })

  return {
    rafScore: data ?? null,
    isPending: canQuery && isPending,
  }
}
